const e = {
  name: "ArrowCircleDownFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM13 7H11V13.5859L7.99991 10.5858L6.58569 12L11.9999 17.4142L17.4141 12L15.9999 10.5858L13 13.5857V7Z" fill="currentColor"/>
</svg>
  `
};
export {
  e as ArrowCircleDownFilled
};
